import { render, staticRenderFns } from "./select-mch.vue?vue&type=template&id=181c1fb6&"
import script from "./select-mch.vue?vue&type=script&lang=ts&"
export * from "./select-mch.vue?vue&type=script&lang=ts&"
import style0 from "./select-mch.vue?vue&type=style&index=0&id=181c1fb6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports